<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-02 14:55:07
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-12-15 20:57:49
-->
<template>
	<div>
		<el-drawer
			:visible.sync="drawer"
			class="handover"
			custom-class="drawer-wrapper"
			:wrapperClosable="false"
			@closed="handleClose"
			ref="drawer"
			size="800px"
		>
			<div slot="title" class="flex-row">
				<div class="fz-16 color-gy-9 mr-16" style="font-weight: 700">交接人</div>
				<span @click="handleClose" @mouseenter="iconClass = 'i-back-hover'" @mouseleave="iconClass = 'i-back'">
					<i :class="iconClass" class="mr-8" />返回上一步
				</span>
			</div>
			<div class="p-16">
				<div class="content pt-20">
					<div class="title-line yx-pingfang-Medium"> 选择交接人 </div>
					<p class="flex-row fz-14 pt-18 yx-color-text-primary" v-if="isDaren">
						已为您筛选出 用户标签含【达人商务】<explain
							content="负责对接达人有认领达人权限的人"
							placement="top"
							class="ml-2 mr-2"
							icon="icon-a-help-circlebangzhu-mian"
						/>的用户！
					</p>
					<div class="flex-row mt-24 search">
						<el-input placeholder="请输入用户名称" v-model="nickname"></el-input>
						<el-button class="searchBtn" @click="search">搜索</el-button>
					</div>
					<div class="table mt-24 gray-table-header">
						<el-table
							:data="list"
							header-row-class-name="table-header-row"
							row-class-name="table-row"
							ref="table"
							@row-click="singleElection"
							v-loading="loading"
						>
							<el-table-column width="30" align="right">
								<template slot-scope="{ row }">
									<el-radio v-model="to_user_id" :label="row.id">&nbsp;</el-radio>
								</template>
							</el-table-column>
							<el-table-column label="用户名称" width="180">
								<template slot-scope="{ row }">
									<rdText colorStyle="yx-pingfang-Medium" bigger> {{ row.nickname }} </rdText>
								</template>
							</el-table-column>
							<el-table-column label="手机号" width="120">
								<template slot-scope="{ row }">
									<div class="font-h5-regular color-gy-9 fz-12">
										{{ row.mobile }}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="部门" width="150">
								<template slot-scope="{ row }">
									<rdText colorStyle="yx-pingfang-Medium"> {{ row.deptName }} </rdText>
								</template>
							</el-table-column>
							<el-table-column label="用户角色" width="232">
								<template slot-scope="{ row }">
									<div class="font-h5-regular color-gy-9">
										<Tag :content="item" style="display: inline-block" v-for="(item, index) in row.roleName" :key="index" class="mr-4"></Tag>
									</div>
								</template>
							</el-table-column>
						</el-table>
						<yx-pagination
							:total="total"
							:current-page="pageInfo.page_index"
							:page-size="pageInfo.page_size"
							@size-change="sizeChange"
							@current-change="currentChange"
						/>
					</div>
				</div>
			</div>

			<div class="footer flex-row-align-center flex-just-end yx-background-white">
				<div>
					<el-button @click="handleClose">取 消</el-button>
					<el-button type="primary" @click="submit" :disabled="isDisabled">提交</el-button>
				</div>
			</div>
		</el-drawer>
		<el-dialog :visible.sync="visible" title="温馨提示" width="540px">
			<div class="flex-row-align-center mb-12">
				<i class="el-icon-info yx-color-warning fz-18" />
				<span class="ml-6 color-gy-9"
					>是否确认将 <span class="yx-color-primary">{{ selectAll ? selectTotal : selectTodoList.length }}</span> 个{{ roleName }} 移交给
					{{ from_user_name }}？</span
				>
			</div>
			<div class="footer-dialog" slot="footer">
				<el-button @click="visible = false">取 消</el-button>
				<el-button type="primary" @click="confrim">确 认</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';
import Tag from '@/components/ui/tag';
import Explain from '@/components/common/explain';
import { relayAnchor, relayInstitution, relayProduct } from '@/api/teamManage';
import { relateToList } from '@/api/teamManage';
import { zsRoleType, drRoleType } from '@/utils/dataMap';
export default {
	components: {
		Tag,
		Explain,
	},
	computed: {
		isDisabled({ to_user_id }) {
			return !to_user_id;
		},
		isDaren({ handoverType }) {
			return handoverType === 1;
		},
		isHead({ handoverType }) {
			return handoverType === 2;
		},
		isShop({ handoverType }) {
			return handoverType === 3;
		},
		roleName({ isDaren, isHead, isShop }) {
			return isDaren ? '达人' : isHead ? '团长' : isShop ? '商品' : '';
		},
	},
	data() {
		return {
			drawer: false,
			visible: false,
			list: [],
			loading: false,
			from_user_id: '',
			to_user_id: '',
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			checkList: [],
			handoverType: 1,
			selectTodoList: [],
			nickname: '',
			from_user_name: '',

			selectAll: false,
			selectTotal: 0,

			iconClass: 'i-back',
		};
	},

	methods: {
		show({ type, selectTodoList = [], from_user_id, selectAll, selectTotal }) {
			this.from_user_id = from_user_id;
			this.selectTodoList = selectTodoList;
			this.handoverType = type;
			this.getList();
			this.drawer = true;
			this.selectAll = selectAll;
			this.selectTotal = selectTotal;
		},
		async getList() {
			this.loading = true;
			try {
				const { nickname, from_user_id: user_id } = this;

				const { code, data: { list = [], page = {} } = {} } = await relateToList({
					nickname,
					user_id,
					delete: 1, //0全部 1未删除 2已删除
					...this.pageInfo,
					user_type: this.isShop ? zsRoleType.id : drRoleType.id,
				});
				if (code !== 0) return;
				this.loading = false;
				this.list = list;
				this.total = page.item_total;
			} catch (e) {
				console.log(e);
				this.loading = false;
			}
		},
		selectionChange(val) {
			this.selectList = val;
			this.getList();
		},
		seeDetails() {
			this.$refs.handoverDetails.show();
		},
		sizeChange(val) {
			this.pageInfo.page_size = val;
			this.getList();
		},
		currentChange(val) {
			this.pageInfo.page_index = val;
			this.getList();
		},
		singleElection({ id, nickname }) {
			this.to_user_id = id;
			this.from_user_name = nickname;
		},
		handleSelectionChange() {},
		submit() {
			this.visible = true;
		},
		confrim: debounce(async function () {
			const { isDaren, isHead, from_user_id, to_user_id, selectTodoList } = this;
			try {
				if (isDaren) {
					let anchor_ids = selectTodoList.map(item => item.anchor_id);
					await relayAnchor({ from_user_id, to_user_id, anchor_ids, all: this.selectAll ? 1 : 0 });
					this.$message.success('操作成功！');
					this.visible = false;
					this.handleClose();
					this.$emit('refresh');
				} else if (isHead) {
					let team_institution_ids = selectTodoList.map(item => item.team_institution_id);
					await relayInstitution({ from_user_id, to_user_id, team_institution_ids, all: this.selectAll ? 1 : 0 });
					this.$message.success('操作成功！');
					this.visible = false;
					this.handleClose();
					this.$emit('refresh');
				} else {
					let productIds = selectTodoList.map(item => item.id);
					await relayProduct({ fromUserId: from_user_id, toUserId: to_user_id, productIds, isRelayAll: this.selectAll ? 1 : 0 });
					this.$message.success('操作成功！');
					this.visible = false;
					this.handleClose();
					this.$emit('refresh');
				}
			} catch (e) {}
		}, 1000),
		handleClose() {
			this.reset();
			this.drawer = false;
		},
		reset() {
			this.nickname = '';
			this.to_user_id = '';
			this.from_user_id = '';
			this.from_user_name = '';
		},
		search() {
			this.pageInfo = {
				page_index: 1,
				page_size: 10,
			};
			this.getList();
		},
	},
};
</script>
<style lang="less" scoped>
.title-line {
	color: @color-gy9;
	font-size: 16px;
	position: relative;
	padding-left: 10px;

	&::before {
		position: absolute;
		content: ' ';
		width: 3px;
		height: 17px;
		background: @color-primary;
		left: 0px;
		top: 3px;
		border-radius: 100px;
	}
}
.handover {
	/deep/ .el-drawer__header span {
		&:hover {
			color: @color-primary;
		}
		font-size: 14px;
		color: @color-gy7;
		cursor: pointer;
	}
	.content {
		position: relative;
		padding: 0px 20px 0px 20px;
		margin-bottom: 52px;
		background: #fff;
		border-radius: 8px;
		.search {
			/deep/ .el-input {
				input {
					border-right: none;
				}
			}
		}
		.searchBtn {
			height: 32px;
			width: 76px;
			background-color: @color-b4;
			color: #ffffff;
			font-size: 13px;
			border-radius: 4px;
			border: none;
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
			margin-left: -4px;
			z-index: 1;
		}
	}

	.footer {
		position: absolute;
		width: 100%;
		bottom: 0;
		padding: 10px;
		border-top: 1px solid #f0f1f5;
		box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.06);
		z-index: 999;
	}
}
.warn-img {
	width: 16px;
	height: 16px;
}
</style>
